/**
 * Base-map styles the tile switcher offers. Both are keyless public services:
 * OpenStreetMap's standard raster and Esri's World Imagery, the de facto free
 * satellite layer (used with the attribution Esri requires).
 */
export type ITileStyle = {
    key: string;
    label: string;
    url: string;
    attribution: string;
    maxZoom: number;
};

export const TILE_STYLES: ITileStyle[] = [
    {
        key: 'streets',
        label: 'Map',
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19,
    },
    {
        key: 'satellite',
        label: 'Satellite',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community',
        maxZoom: 19,
    },
];

export const DEFAULT_TILE_STYLE_KEY = TILE_STYLES[0].key;

const STORAGE_KEY = 'reffie.map-tile-style';

/** The user's last choice, shared across every map surface. */
export const readStoredTileStyleKey = (): string => {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return TILE_STYLES.some((style) => style.key === stored) && stored != null ?
        stored :
        DEFAULT_TILE_STYLE_KEY;
};

export const storeTileStyleKey = (key: string): void => {
    window.localStorage.setItem(STORAGE_KEY, key);
};
